<template>
  <div>
    <pc-dialog class="dialog" title="已获得奖励" :visible.sync="dialogVisible" @close="close" @confirm="handleClaim">
      <template #content>
        <div class="list" v-if="hasPrize">
          <div
            v-for="(item, key) in prizeList"
            :key="key"
            class="gift-item"
          >
            <div class="left">
              <div class="image">
                <img :src="getImg(item.icon)" />
              </div>
            </div>
            <div class="right">
              <div class="top"><span>{{ item.name }}</span>{{ item.status == 1 ? '（已领取）' : '' }}</div>
              <div class="expire">有效期：{{ item.effectTime }}</div>
            </div>
          </div>
        </div>
        <div class="empty" v-else>暂无邀请奖励</div>
      </template>
      <template #btn>
        <div class="gift-btn" v-if="hasPrize"></div>
        <div class="confirm-btn" v-else></div>
      </template>
    </pc-dialog>
    <bind-dialog :visible.sync="bindDialogVisible" :prizeList="prizeList" @success="handleBindSuccess" />
  </div>
</template>

<script>
import PcDialog from '../dialog/Index.vue'
import BindDialog from '@/views/pc/components/bindDialog/Index.vue'

import prizeDialogMixins from '@/mixins/prizeDialogMixins.js'

export default {
  name: 'PcPrizeDialog',
  mixins: [prizeDialogMixins],
  components: {
    PcDialog,
    BindDialog,
  },
}
</script>

<style lang="scss" scoped>
.dialog ::v-deep {
  .content {
    top: 140px;
  }

  .btn-box {
    margin-top: 20px;
  }
}

.list {
  height: 380px;
  overflow-y: auto;
}

.gift-item {
  display: flex;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;

  &:not(:first-of-type) {
    margin-top: 15px;
  }

  .left {
    margin-right: 30px;
  }

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 108px;
    background: url('~@/assets/img/pc/prize_bg2.png') no-repeat;
    background-size: 100%;

    img {
      max-width: 80px;
      max-height: 80px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: bold;
    font-family: Noto Serif SC;

    .top {
      margin-bottom: 20px;
      
      span {
        font-size: 24px;
        color: #613811;
      }
    }

    .expire {
      font-size: 20px;
      color: #aaa;
    }
  }
}

.empty {
  margin-bottom: 100px;
  text-align: center;
  font-size: 20px;
}

.gift-btn {
  margin: 0 auto;
  width: 198px;
  height: 53px;
  background: url('~@/assets/img/pc/gift_btn2.png') no-repeat;
  cursor: pointer;
}
</style>